import React, { useState, useEffect } from 'react';
import api from '../../services/api';

const DIAS_SEMANA = ['L', 'M', 'X', 'J', 'V', 'S', 'D'];
const MESES = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];

const TIPO_COLORS = {
  servicio: { bg: '#eaf3de', color: '#3b6d11', label: '🚂' },
  guardia:  { bg: '#e8f0fe', color: '#1a56db', label: '🛡' },
  trabajos: { bg: '#faeeda', color: '#854f0b', label: '🔧' },
};

export default function ProximosServicios() {
  const [tab, setTab] = useState('lista');
  const [servicios, setServicios] = useState([]);
  const [mesActual, setMesActual] = useState(new Date());

  useEffect(() => {
    api.get('/planificacion/mis-servicios').then(r => setServicios(r.data)).catch(() => {});
  }, []);

  const año = mesActual.getFullYear();
  const mes = mesActual.getMonth();
  const primerDia = new Date(año, mes, 1);
  const diasEnMes = new Date(año, mes + 1, 0).getDate();
  const inicioDia = primerDia.getDay() === 0 ? 6 : primerDia.getDay() - 1;

  const diasConServicio = new Set(
    servicios.filter(s => {
      const f = new Date(s.fecha + 'T12:00:00');
      return f.getFullYear() === año && f.getMonth() === mes;
    }).map(s => new Date(s.fecha + 'T12:00:00').getDate())
  );

  const hoy = new Date().toISOString().split('T')[0];
  const proximos = servicios.filter(s => s.fecha >= hoy);
  const anteriores = servicios.filter(s => s.fecha < hoy).reverse();

  return (
    <div>
      <h2 style={{ fontSize: 20, fontWeight: 600, margin: '0 0 16px' }}>Próximos servicios</h2>

      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        {[['lista', '📋 Lista'], ['calendario', '📅 Calendario']].map(([val, label]) => (
          <button key={val} onClick={() => setTab(val)} style={{
            flex: 1, padding: '10px', borderRadius: 10, border: 'none', cursor: 'pointer',
            fontSize: 13, fontWeight: 500,
            background: tab === val ? '#1a1a1a' : '#fff',
            color: tab === val ? '#fff' : '#555'
          }}>{label}</button>
        ))}
      </div>

      {tab === 'lista' && (
        <div>
          {proximos.length > 0 && (
            <div style={{ marginBottom: 20 }}>
              <div style={{ fontSize: 11, fontWeight: 600, color: '#888', marginBottom: 8, textTransform: 'uppercase', letterSpacing: 0.5 }}>Próximos</div>
              {proximos.map(s => {
                const tipo = s.tipo || 'servicio';
                const colores = TIPO_COLORS[tipo] || TIPO_COLORS.servicio;
                const fecha = new Date(s.fecha + 'T12:00:00');
                return (
                  <div key={s.id} style={{ background: '#fff', borderRadius: 12, padding: 14, marginBottom: 8, border: '1px solid #e5e5e5' }}>
                    <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                      <div style={{ background: colores.bg, borderRadius: 8, padding: '8px 10px', fontSize: 18 }}>
                        {colores.label}
                      </div>
                      <div>
                        <div style={{ fontWeight: 600, fontSize: 14 }}>{s.servicio_codigo || s.turno_nombre}</div>
                        <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>
                          {fecha.toLocaleDateString('es-ES', { weekday: 'long', day: 'numeric', month: 'long' })}
                        </div>
                        <div style={{ fontSize: 12, color: '#555', marginTop: 2 }}>
                          {s.hora_inicio?.substring(0,5)} — {s.hora_fin?.substring(0,5)} · {s.base}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          {anteriores.length > 0 && (
            <div>
              <div style={{ fontSize: 11, fontWeight: 600, color: '#888', marginBottom: 8, textTransform: 'uppercase', letterSpacing: 0.5 }}>Anteriores</div>
              {anteriores.slice(0, 10).map(s => {
                const tipo = s.tipo || 'servicio';
                const colores = TIPO_COLORS[tipo] || TIPO_COLORS.servicio;
                const fecha = new Date(s.fecha + 'T12:00:00');
                return (
                  <div key={s.id} style={{ background: '#fff', borderRadius: 12, padding: 14, marginBottom: 8, border: '1px solid #e5e5e5', opacity: 0.6 }}>
                    <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                      <div style={{ background: colores.bg, borderRadius: 8, padding: '8px 10px', fontSize: 18 }}>
                        {colores.label}
                      </div>
                      <div>
                        <div style={{ fontWeight: 600, fontSize: 14 }}>{s.servicio_codigo || s.turno_nombre}</div>
                        <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>
                          {fecha.toLocaleDateString('es-ES', { weekday: 'long', day: 'numeric', month: 'long' })}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          {servicios.length === 0 && (
            <div style={{ background: '#fff', borderRadius: 14, padding: 40, textAlign: 'center', color: '#aaa' }}>
              <div style={{ fontSize: 32, marginBottom: 8 }}>📋</div>
              <div>Sin servicios asignados</div>
            </div>
          )}
        </div>
      )}

      {tab === 'calendario' && (
        <div style={{ background: '#fff', borderRadius: 14, padding: 16 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
            <button onClick={() => setMesActual(new Date(año, mes - 1, 1))} style={{ border: 'none', background: 'none', cursor: 'pointer', fontSize: 18, color: '#555' }}>‹</button>
            <span style={{ fontWeight: 600, fontSize: 15 }}>{MESES[mes]} {año}</span>
            <button onClick={() => setMesActual(new Date(año, mes + 1, 1))} style={{ border: 'none', background: 'none', cursor: 'pointer', fontSize: 18, color: '#555' }}>›</button>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', marginBottom: 8 }}>
            {DIAS_SEMANA.map(d => (
              <div key={d} style={{ textAlign: 'center', fontSize: 11, fontWeight: 600, color: '#aaa', padding: '4px 0' }}>{d}</div>
            ))}
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 4 }}>
            {Array.from({ length: inicioDia }).map((_, i) => <div key={`e${i}`} />)}
            {Array.from({ length: diasEnMes }).map((_, i) => {
              const dia = i + 1;
              const hoyObj = new Date();
              const esHoy = dia === hoyObj.getDate() && mes === hoyObj.getMonth() && año === hoyObj.getFullYear();
              const tieneServicio = diasConServicio.has(dia);
              return (
                <div key={dia} style={{
                  textAlign: 'center', padding: '8px 2px', borderRadius: 8, fontSize: 13,
                  fontWeight: tieneServicio || esHoy ? 600 : 400,
                  background: esHoy ? '#1a1a1a' : tieneServicio ? '#eaf3de' : 'transparent',
                  color: esHoy ? '#fff' : tieneServicio ? '#3b6d11' : '#333',
                }}>
                  {dia}
                  {tieneServicio && !esHoy && <div style={{ width: 4, height: 4, borderRadius: '50%', background: '#16a34a', margin: '2px auto 0' }} />}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
